import { render, staticRenderFns } from "./task_edit_priority.vue?vue&type=template&id=7e489586&scoped=true"
import script from "./task_edit_priority.vue?vue&type=script&lang=js"
export * from "./task_edit_priority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e489586",
  null
  
)

export default component.exports